import React, { Component } from "react";
import Search from "./search";

class SearchComponent extends Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error) {
    /* eslint-disable-next-line */
    console.log(error);
  }

  render() {
    return (
      <div>
        <Search api={this.props} />
      </div>
    );
  }
}

export default SearchComponent;
